import type { NextPage } from 'next'
import ImgOg from 'assets/images/content/gesundheit_balance.jpg'
import { Layout, Main } from 'layout'
import { canonicalUrl } from 'lib/utils'
import Head from 'next/head'
import PageContent from 'pageContent/LebensArtAkademie'

const AngebotePrivatpersonen: NextPage = () => (
  <Layout>
    <Head>
      <title>LebensArt-Akademie | FrauenCoach.jetzt</title>
      <meta
        name="description"
        key="description"
        content={`Schenke dir ein zufriedenes Leben, jetzt! Ich nehme dich mit. Online-Akademie LebensArt`}
      />
      <meta
        name='keywords'
        key='keywords'
        content={`Coaching Berlin, Coach Privatpersonen, Coach Frauen, Frauencoach, Coach für Frauen, Onlinekurs, Kurs, LebensArt, Online-Akademie, Online-Akademie LebensArt`}
      />
      <meta key="ogImage" property="og:image" content={ImgOg?.src} />
      <meta key="twitterImage" property="twitter:image" content={ImgOg?.src} />

      <link key="canonical" rel="canonical" href={canonicalUrl('/lebensart-akademie')} />
    </Head>
    <Main>
      <PageContent />
    </Main>
  </Layout>
)

export default AngebotePrivatpersonen
